<template>
  <v-dialog
    :max-width="$vuetify.breakpoint.xsOnly ? '95%' : '480px'"
    persistent
    v-model="component.exchangeDialog"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subtitle-1 font-weight-bold grey--text">
          Identificador de Troca
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon small :disabled="searching" @click="component.cancelExchangeCredit()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <v-card-text class="pt-4">
        <v-alert v-if="errorMessage" type="error" dense text class="mb-3">
          {{ errorMessage }}
        </v-alert>
        <v-form ref="searchForm">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="component.codeCupomSearch"
                outlined
                dense
                :rules="[v => !!v || 'Código obrigatório']"
                label="Código do identificador de troca"
                :disabled="searching"
                @keyup.enter="!component.codeCupomSearch || searching ? null : handleSearch()"
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                block
                color="success"
                :disabled="!component.codeCupomSearch || searching"
                :loading="searching"
                @click="handleSearch"
              >
                Pesquisar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>



<script>
import { GET_ALL_ENTERPRISE } from "@/store/actions/enterprise";
export default {
  props: {
    component: Object,
  },
  components: {},
  data: () => ({
    listEnterprise: Array(),
    searching: false,
    errorMessage: '',
  }),
  methods: {
    async handleSearch() {
      this.searching = true;
      this.errorMessage = '';
      try {
        await this.component.searchCupom();
      } catch (e) {
        this.errorMessage = e.message || 'Erro ao pesquisar cupom. Tente novamente.';
      } finally {
        this.searching = false;
      }
    },
    getAll(page = 1) {
      const payload = {
        page,
        limit: 10,
      };
      this.$store.dispatch(GET_ALL_ENTERPRISE, payload).then((response) => {
        this.listEnterprise = [...response.data];
      });
    },
  },
  computed: {},
  created() {
    this.getAll();
  },
};
</script>
